import { TokenResponse } from "@api/Responses/TokenResponse.ts";

export const storeToken = (tokenResponse: TokenResponse) => {
  localStorage.setItem("token", JSON.stringify(tokenResponse));
};

export const getStoredToken = (): TokenResponse | null => {
  const tokenDataString = localStorage.getItem("token");
  if (!tokenDataString) return null;

  return JSON.parse(tokenDataString) as TokenResponse;
};

export const isTokenValid = (tokenResponse: TokenResponse): boolean => {
  if (!tokenResponse.received_at) return false;

  const now = new Date().getTime();
  const expiryTime =
    tokenResponse.received_at + tokenResponse.expires_in * 1000 - 60000;
  return now < expiryTime;
};

export const isRefreshTokenValid = (tokenResponse: TokenResponse): boolean => {
  if (!tokenResponse.received_at) return false;

  const now = new Date().getTime();
  const expiryTime =
    tokenResponse.received_at + tokenResponse.refresh_expires_in * 1000;
  return now < expiryTime;
};

export const clearToken = () => {
  const i18nextLng = localStorage.getItem("i18nextLng");
  const didAdminComeIn = localStorage.getItem("didAdminComeIn");
  localStorage.clear();
  if (i18nextLng) localStorage.setItem("i18nextLng", i18nextLng);
  if (didAdminComeIn) localStorage.setItem("didAdminComeIn", didAdminComeIn);
};
